<script setup>
import {onMounted, ref, defineProps, computed, nextTick, watch} from 'vue'

const props = defineProps({
  blue: {
    type: Boolean,
    default: false
  },
  purple: {
    type: Boolean,
    default: false
  },
  teal: {
    type: Boolean,
    default: false
  },
  red: {
    type: Boolean,
    default: false
  }
});
</script>


<template>
  <div class="b" :class="{blue: props.blue, purple: props.purple, teal: props.teal, red: props.red}">
    <slot/>
  </div>
</template>

<style scoped>

.b {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: .6rem 1.6rem;
  display: inline-block;
  transition: var(--transition-fast);
}

.b:hover {
  cursor: pointer;
  color: var(--text-heading);
  background-color: var(--surface-raised);
}

.b.blue {
  background-color: var(--color-info);
  color: var(--text-heading);
}

.b.blue:hover {
  background-color: var(--color-info)
}

.b.purple {
  background-color: var(--accent-text);
  color: var(--text-heading);
}

.b.purple:hover {
  background-color: var(--accent-text);
}

.b.teal {
  background-color: var(--color-success);
  color: var(--text-heading);
}

.b.teal:hover {
  background-color: var(--color-success);
}

.b.red {
  background-color: rgba(239, 68, 68, 0.15);
  color: var(--color-error-text);
}

.b.red:hover {
  background-color: rgba(239, 68, 68, 0.28);
  color: white;
}

</style>
